import { routes } from "../../assets/constants";
import { ApiMethod } from "../models/api-types.type";
import { useAuthContext } from "./use-auth-context.hook";
import { EmailError, Invitation, InvitationDelivery } from "./use-invitations-api.hook";

export interface TeamMember {
    _id: string;
    email: string;
    firstname?: string;
    lastname?: string;
    isEnabled: boolean;
    /** false while someone who joined from a shared link hasn't confirmed their email yet. */
    isVerified: boolean;
    createdAt?: string;
}

/** The plan's seats: how many accounts the vendor can have. `limit` -1 = unlimited. */
export interface TeamSeats {
    limit: number;
    /** Enabled accounts. */
    used: number;
    /** Places pending invitations hold. */
    reserved: number;
}

/** A vendor admin's own team: its users, its invitations, and inviting more. */
export const useTeamApi = () => {
    const { sendAuthGuardedRequest } = useAuthContext();

    const getTeam = () =>
        sendAuthGuardedRequest(ApiMethod.GET, routes.team.base) as Promise<{ members: TeamMember[]; invitations: Invitation[]; seats?: TeamSeats }>;

    return {
        getTeam,
        invite: (input: { delivery: InvitationDelivery; email?: string; maxUses?: number }) =>
            sendAuthGuardedRequest(ApiMethod.POST, routes.team.invitations, input) as Promise<{
                invitation: Invitation; link?: string; emailSent?: boolean; emailError?: EmailError;
            }>,
        // The shape the shared invitations list reads from.
        listInvitations: async () => (await getTeam()).invitations,
        resendInvitation: (id: string) =>
            sendAuthGuardedRequest(ApiMethod.POST, routes.team.resend(id)) as Promise<{ emailSent: boolean; emailError?: EmailError }>,
        revokeInvitation: (id: string) => sendAuthGuardedRequest(ApiMethod.POST, routes.team.revoke(id)),
    };
};
